module.exports = __webpack_public_path__ + "static/img/buy-img.0457453.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy-img.png
// module id = 3C5f
// module chunks = 1